
import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  children: React.ReactNode;
  href?: string;
  to?: string;
  isPage?: boolean;
  mobile?: boolean;
  isScrolled?: boolean;
  isHomePage?: boolean;
  onClick?: () => void;
  className?: string;
}

const NavLink: React.FC<NavLinkProps> = ({ 
  children, 
  href, 
  to, 
  isPage, 
  mobile, 
  isScrolled, 
  isHomePage = false,
  onClick, 
  className 
}) => {
  const linkClassName = cn(
    'font-medium transition-colors duration-300',
    mobile ? 'text-white block w-full hover:text-singu-yellow' : 
    'text-white hover:text-singu-yellow',
    className
  );

  if (isPage && to) {
    return (
      <Link
        to={to}
        className={linkClassName}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <HashLink
        to={href}
        smooth
        className={linkClassName}
        onClick={onClick}
      >
        {children}
      </HashLink>
    );
  }

  return (
    <a
      href={href}
      className={linkClassName}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

export default NavLink;
